import { BASE_ASSETS } from "@assets/templates/constants";
import type { TemplateDefinition } from "@assets/templates/types";
import { DocumentInputContentV1 } from "@demo/types/documentContent";

export const golfSwingExample: TemplateDefinition = {
  mode: "compose",
  slug: "golf-swing-example",
  version: 1,
  title: "Golf swing",
  description: "Form comparison",
  thumbnailUuid: BASE_ASSETS.golfSwing1Poster.uuid,
  assets: [BASE_ASSETS.golfSwing1Video, BASE_ASSETS.golfSwing2Video],
  request: {
    model: "perceptron-mk1.5",
    system: [],
    user: [
      {
        type: "media",
        value: [
          {
            type: "video",
            value: {
              uuid: BASE_ASSETS.golfSwing1Video.uuid,
              extension: BASE_ASSETS.golfSwing1Video.extension,
            },
          },
          {
            type: "video",
            value: {
              uuid: BASE_ASSETS.golfSwing2Video.uuid,
              extension: BASE_ASSETS.golfSwing2Video.extension,
            },
          },
        ],
      },
      {
        type: "paragraph",
        value: {
          type: "text",
          value: "Describe the differences in golfing form. Focus on rotation, posture, and general swing mechanics.",
        },
      },
    ],
    outputAnnotations: false,
    variables: {},
    annotationFormat: null,
    enableThinking: true,
  } satisfies DocumentInputContentV1,
};
